import CigePlanillas from '../../components/cigeplanillas/cigeplanillas';

const CigePlanillasPage = () => {
  return <CigePlanillas />;
};

export default CigePlanillasPage;
